module.exports = __webpack_public_path__ + "static/media/image3.28470933.jpg";